<template>
  <div class="speed-reading" :class="status">
    <div v-if="status === 'loading'" class="spinner">
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
    </div>
    <div v-if="status === 'error'" class="location-error">
      <p>{{ $t("location-read-error") }}</p>
    </div>
    <div v-else class="topline-readings">
      <div class="reading reading--avg-speed">
        <div class="reading__value">
          <i18n-t keypath="location-format" tag="div">
            <template v-slot:value>
              <span>
                {{ averageSpeed }}
              </span>
            </template>
            <template v-slot:units>
              <span>{{ $t(`speed-units.${speedUnits}`) }}</span>
            </template>
          </i18n-t>
        </div>
        <div class="reading__label">{{ $t("avg-speed") }}</div>
      </div>
      <div class="reading reading--speed">
        <div class="reading__value">
          <i18n-t keypath="location-format" tag="div">
            <template v-slot:value>
              <span>
                {{ currentSpeed }}
              </span>
            </template>
            <template v-slot:units>
              <span>{{ $t(`speed-units.${speedUnits}`) }}</span>
            </template>
          </i18n-t>
        </div>
        <div class="reading__label">{{ $t("current-speed") }}</div>
      </div>
      <div class="reading">
        <div class="reading__value" v-if="currentHeading !== null">
          {{ currentHeading }}
        </div>
        <div class="reading__label">{{ $t("heading") }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { convertSpeed, numberFormatted, headingFormatted } from '@/helpers';

export default {
  data() {
    return {
      locationFormat: this.$t('location-format'),
    };
  },
  props: ['locations', 'speedUnits', 'status'],
  computed: {
    latestLocation() {
      return this.locations[this.locations.length - 1];
    },
    currentHeading() {
      if (!this.latestLocation) {
        return null;
      }
      const heading = this.latestLocation.coords.heading || null;
      return headingFormatted(heading);
    },
    currentSpeed() {
      let speed = 0;
      if (this.latestLocation) {
        speed = this.latestLocation.coords.speed || 0;
      }
      return this.formattedSpeed(speed);
    },
    averageSpeed() {
      let readings = 0;
      let totalSpeed = 0;
      this.locations.forEach((location) => {
        if (location.coords.speed) {
          totalSpeed += location.coords.speed;
          readings += 1;
        }
      });
      const speed = (totalSpeed / readings) || 0;
      return this.formattedSpeed(speed);
    },
  },
  methods: {
    formattedSpeed(speed) {
      const speedConverted = convertSpeed(speed, { units: this.speedUnits });
      return numberFormatted(speedConverted, { locale: this.$t.locale });
    },
  }
};
</script>
